import { Typography, Link } from '@mui/material';
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from "axios";
import AuthLayout from '../components/AuthLayout';
const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [token, setToken] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        // Extract token from URL
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get('token');
        if (urlToken) {
            setToken(urlToken);
        }
        else {
            setSnackbarSeverity('error');
            setSnackbarMessage('Токен сброса отсутствует или неверен.');
            setOpenSnackbar(true);
        }
    }, []);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const handleKeyDown = (key) => {
        if (key === 'Enter') {
            submit();
        }
    };
    const submit = () => {
        if (isSubmitting)
            return;
        if (password === "" || confirmPassword === "") {
            setSnackbarSeverity('error');
            setSnackbarMessage('Пожалуйста, заполните все поля.');
            setOpenSnackbar(true);
            return;
        }
        if (password !== confirmPassword) {
            setSnackbarSeverity('error');
            setSnackbarMessage('Пароли не совпадают.');
            setOpenSnackbar(true);
            return;
        }
        if (password.length < 6) {
            setSnackbarSeverity('error');
            setSnackbarMessage('Пароль должен содержать минимум 6 символов.');
            setOpenSnackbar(true);
            return;
        }
        if (!token) {
            setSnackbarSeverity('error');
            setSnackbarMessage('Токен сброса отсутствует или неверен.');
            setOpenSnackbar(true);
            return;
        }
        setIsSubmitting(true);
        let data = new FormData();
        data.append('token', token);
        data.append('new_password', password);
        axios({
            method: "post",
            url: "/auth/reset-password",
            data: data,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
            if (response.data.success) {
                setSnackbarSeverity('success');
                setSnackbarMessage('Пароль успешно изменен. Перенаправление на страницу входа...');
                setOpenSnackbar(true);
                setTimeout(() => window.location.href = '/login', 2000);
            }
            else {
                setSnackbarSeverity('error');
                setSnackbarMessage(response.data.message || 'Не удалось изменить пароль.');
                setOpenSnackbar(true);
                setIsSubmitting(false);
            }
        })
            .catch(function (error) {
            var _a, _b;
            console.log(error);
            setSnackbarSeverity('error');
            setSnackbarMessage(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || "Произошла ошибка при сбросе пароля");
            setOpenSnackbar(true);
            setIsSubmitting(false);
        });
    };
    return (React.createElement(AuthLayout, { snackbarOpen: openSnackbar, snackbarMessage: snackbarMessage, snackbarSeverity: snackbarSeverity, onCloseSnackbar: handleCloseSnackbar },
        React.createElement("div", { style: { marginBottom: '30px' } },
            React.createElement("div", null,
                React.createElement("div", { style: { marginBottom: '30px' } },
                    React.createElement(Typography, { variant: 'h5', gutterBottom: true }, "\u0417\u0430\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C"),
                    React.createElement(Typography, { variant: 'body1' }, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.")),
                React.createElement("div", null,
                    React.createElement(Stack, { spacing: 1 },
                        React.createElement(TextField, { required: true, id: "password-input", label: "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", type: "password", onChange: (e) => setPassword(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: !token || isSubmitting }),
                        React.createElement(TextField, { required: true, id: "confirm-password-input", label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", type: "password", onChange: (e) => setConfirmPassword(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: !token || isSubmitting })),
                    React.createElement("div", { className: "submitMargin" },
                        React.createElement(Button, { onClick: () => submit(), variant: "contained", disabled: !token || isSubmitting }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C")),
                    React.createElement("div", { style: { marginTop: '20px' } },
                        React.createElement(Typography, { variant: 'body2' },
                            React.createElement(Link, { href: "/login", style: { cursor: 'pointer' } }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0432\u0445\u043E\u0434\u0430"))))))));
};
export default ResetPassword;
